export default __webpack_public_path__ + "static/media/lotus-flower.eeaade91.png";